<template>
  <div class="content-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-2">
      <h2 class="content-header-title" style="border-right: none;">{{project.short_name}} ⇝ Категории полей</h2>
      <div class="btn-group float-right" role="group">
        <button class="compose btn btn-success" @click="copyFromAnotherProject()">Скопировать из другого проекта</button>
        <button class="compose btn btn-primary" @click="newRecord()">Добавить</button>
      </div>

    </div>

    <div class="card">
      <div class="card-header p-0">
        <div class="d-flex justify-content-between w-100">
          <div class="input-group input-group-merge shadow-none m-0 flex-grow-1">
            <div class="input-group-prepend">
              <span class="input-group-text border-0">
                <font-awesome-icon icon="fas fa-search" />
              </span>
            </div>
            <input type="text" @input="search()" v-model="searchQuery" class="form-control files-filter border-0 bg-transparent" placeholder="Поиск" />
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body h-100" style="padding: 0;">
        <div class="table-striped">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 5%;">#</th>
                <th style="width: 80%;">Наименование</th>
                <th style="width: 15%;">Действия</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="categories.length > 0">
                <tr v-for="(category, index) in categories">
                  <td>{{index + 1}}</td>
                  <td>{{category.name}}</td>
                  <td>
                    <div class="btn-group">
                      <a class="btn btn-sm btn-primary" @click.prevent="editRecord(category)" href="#"><font-awesome-icon icon="fas fa-edit" /></a>
                      <a class="btn btn-sm btn-danger" @click.prevent="deleteRecord(category.id)" href="#"><font-awesome-icon icon="fas fa-trash" /></a>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="3">
                    Нет данных для отображения
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <nav class="justify-content-between d-flex mt-2 align-items-center">
          <div class="p-2">
            <label for="inputState" class="form-label mb-0">На странице: </label>
            <select class="form-select" v-model="perPage" @change="changePerPage()">
              <option :value="value" v-for="value in perPageList">{{value}}</option>
            </select>
          </div>
          <ul class="pagination mb-0">
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(firstPage)" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-fast-backward" /> Первая
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="prevPage()" href="#">
                <font-awesome-icon class="mr-1" icon="fas fa-step-backward" /> Предыдущая
              </a>
            </li>
            <li class="page-item" :class="{ 'active': page.active }" v-for="page in visiblePages">
              <a class="page-link" @click.prevent="selectPage(page.name)" href="#">{{page.name}}</a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="nextPage()" href="#">
                Следующая <font-awesome-icon class="ml-1" icon="fas fa-step-forward" />
              </a>
            </li>
            <li class="page-item">
              <a class="page-link" @click.prevent="selectPage(lastPage)" href="#">
                Последняя <font-awesome-icon class="ml-1" icon="fas fa-fast-forward" />
              </a>
            </li>
          </ul>
          <div class="p-2">
            <p class="mb-0">(Всего страниц: {{lastPage}})</p>
          </div>
        </nav>

      </div>
    </div>

    <!-- Field Add/Edit Modal -->
    <div class="modal modal-slide-in fade" id="addNewRecord" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
        <div class="modal-header mb-1">
          <h5 class="modal-title" v-show="!editmode">Добавить</h5>
          <h5 class="modal-title" v-show="editmode">Редактировать</h5>
        </div>
        <form @submit.prevent="editmode ? updateRecord() : createRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label>Наименование</label>
                <input v-model="recordform.name" type="text" placeholder="Наименование" class="form-control" required>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button v-show="editmode" type="submit" class="btn btn-success">Обновить</button>
              <button v-show="!editmode" type="submit" class="btn btn-primary">Создать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

    <!-- Field Add/Edit Modal -->
    <div class="modal modal-slide-in fade" id="copyForm" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content pt-0">
        <div class="modal-header mb-1">
          <h5 class="modal-title">Копирование из другого проекта</h5>
        </div>
        <form @submit.prevent="copyRecord()">
            <div class="modal-body">
              <div class="form-group">
                <label>Выберите проект</label>
                <v-select v-model="copyform.project_id" label="short_name" :reduce="project => project.id" :options="$parent.$parent.projects" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
              <button type="submit" class="btn btn-primary">Скопировать</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- !Field Add/Edit Modal -->

  </div>
</template>

<script>
  export default {
    props: ['id', 'project'],
    computed: {
      startPage() {
        if (this.currentPage < 4) {
          return 1;
        }
        if (this.currentPage == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 1) == this.lastPage) {
          return this.startPage2;
        }

        if ((this.currentPage + 2) == this.lastPage) {
          return this.startPage2;
        }
        return this.currentPage - 3;
      },
      startPage2(){
        if(this.lastPage > 6){
          return this.lastPage - 6;
        }
        if(this.lastPage > 5){
          return this.lastPage - 5;
        }
        if(this.lastPage > 4){
          return this.lastPage - 4;
        }
        if(this.lastPage > 3){
          return this.lastPage - 3;
        }
        if(this.lastPage > 2){
          return this.lastPage - 2;
        }
      },
      visiblePages() {
        let pages = [];
        let start = this.startPage;
        let end = Math.min(this.startPage + 6, this.lastPage);
        for (let i = start; i <= end; i++) {
          pages.push({
            name: i,
            active: i == this.currentPage
          });
        }
        return pages;
      }
    },
    data () {
      return {
        searchQuery: '',
        currentPage: 1,
        lastPage: 1,
        firstPage: 1,
        timeout: null,
        perPage: 50,
        perPageList: [10, 25, 50, 100],
        categories: [],
        recordform: new Form({
          id: null,
          name: null
        }),
        copyform: new Form({
          project_id: null
        }),
        editmode: false,
      }
    },
    methods: {
      copyFromAnotherProject(){
        $('#copyForm').modal('show');
      },
      copyRecord(){
        this.$Progress.start();
        this.copyform.post('/api/project/'+this.id+'/category/copy')
        .then((response)=>{
          $('#copyForm').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.copyform.reset();
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      SuccessToast(){
        Toast.fire({
          icon: 'success',
          title: 'Успешно'
        });
      },
      ErrorToast(){
        Toast.fire({
          icon: 'error',
          title: 'Ошибка'
        });
      },
      editRecord(record){
        this.editmode = true;
        this.recordform.reset();
        this.recordform.id = record.id;
        this.recordform.name = record.name;
        $('#addNewRecord').modal('show');
      },
      newRecord(){
        this.editmode = false;
        this.recordform.reset();
        $('#addNewRecord').modal('show');
      },
      nextPage(){
        if(this.currentPage < this.lastPage){
          this.currentPage++;
          this.loadRecords();
        }
      },
      selectPage(number){
        this.currentPage = number;
        this.loadRecords();
      },
      prevPage(){
        if(this.currentPage > 1){
          this.currentPage--;
          this.loadRecords();
        }
      },
      search(){
        if(this.timeout)
          clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.$Progress.start();
          this.currentPage = 1;
          this.loadRecords();
          this.$Progress.finish();
        }, 500);

      },
      changePerPage(){
        this.currentPage = 1;
        this.loadRecords();
      },
      createRecord(){
        this.$Progress.start();
        this.recordform.post('/api/project/'+this.id+'/category')
        .then((response)=>{
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(()=>{
          this.ErrorToast();
          this.$Progress.fail();
        })
      },
      updateRecord(){
        this.$Progress.start();
        this.recordform.put('/api/project/'+this.id+'/category/'+this.recordform.id)
        .then((response) => {
          $('#addNewRecord').modal('hide');
          this.SuccessToast();
          this.loadRecords();
          this.recordform.reset();
          this.$Progress.finish();
        })
        .catch(() => {
          this.ErrorToast();
          this.$Progress.fail();
        });
      },
      deleteRecord(id){
        Swal.fire({
          title: 'Вы уверены?',
          text: "Это действие нельзя будет отменить",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Да, удалить'
          }).then((result) => {
           if (result.value) {
            this.recordform.delete('/api/project/'+this.id+'/category/'+id).then(()=>{
              this.SuccessToast();
              this.loadRecords();
            }).catch((data)=> {
              this.ErrorToast();
            });
          }
        })
      },
      loadRecords(){
        axios.get('/api/project/'+this.id+'/category?page='+this.currentPage+'&search='+this.searchQuery+'&perPage='+this.perPage).then(({ data }) => {
          this.categories = data.data;
          this.lastPage = data.last_page;
        });
      }
    },
    created() {
      this.$Progress.start();
      this.loadRecords();
      this.$Progress.finish();
    }
  }
</script>
